export const ChineseSimplifiedLabel = {
  Cutomerpanel: '客户面板',
  login: '登录',
  Register: '注册',
  en: '英语',
  fa: '波斯语',
  Business: '公司',
  Phonenumber: '电话号码',
  Continue: '继续',
  phonenumberhasnotregisterd: '电话号码尚未注册',
  Username: '用户名',
  title: '称谓',
  Password: '密码',
  ExOnro: '例如：公司',
  Exstart: '例如：******',
  googleConnected: '已连接 Google',
  facebookConnected: '已连接 Facebook',
  appleConnected: '已连接 Apple ID',
  plsenterphonnumber: '请输入您的电话号码',
  businessNamePlaceholder: '例如：ABC 公司',
  registerBusinessNameLabel: '公司名称',
  firstnnameloginplaceholder: '例如：John',
  lastnameloginplaceholder: '例如：Doe',
  Firstname: '名字',
  Lastname: '姓氏',
  email: '邮箱',
  emailPlaceholder: '（可选）例如：example@example.com',
  comingsoon: '即将推出：',
  comingsoondesc: '如需创建公司账户，请联系我们',
  CustomerAlreadyRegistered: '客户已注册，请登录',
  registerCompleted: '输入验证码',
  googletokenerror: 'Google 令牌问题',
  facebooktokenerror: 'Facebook 令牌问题',
  appletokenerror: 'Apple 令牌问题',
  CustomerNotRegistered: '客户未注册',
  fr: '法语',
  de: '德国',
  InvalidVerificationCode: '验证码无效',
  a: '无法找到您的信息',
  welcome: '欢迎',
  SmsLimitationError: '请稍后重试',
  resendCodeWithTime: '重新发送验证码 (xxx)',
  resendCode: '重新发送验证码',
  VerificationcodePlaceHolder: '例如：1234',
  Verificationcode: '验证码',
  VerificationcodeText: '输入发送至 xxx 的验证码',
  VerificationCodeExpired: '验证码已过期',
  Pending: '待处理',
  Unassigned: '未分配',
  Assigned: '进行中',
  'Em curso': 'Assignée',
  PickedUp: '进行中',
  Started: '进行中',
  statusInProgress: '进行中',
  Done: '完成',
  CustomerCanceled: '已取消',
  DriverCanceled: '已取消',
  SupportCanceled: '已取消',
  Arrived: '进行中',
  new: '新',
  Historyofyourorderswillbehere: '您的订单历史记录将在此处显示',
  otherdropoffs: '其他下单记录',
  Orderhistory: '订单历史记录',
  Noorder: '无订单',
  loadingList: '请耐心等待接收信息',
  loadingError: '获取信息时出现问题',
  retry: '请重试',
  Create_your_first_requst: '创建新订单',
  List_of_you_active_orders_will_be_here: '您的有效订单列表将在此处显示',
  Aboutus: '关于我们',
  Readour: '阅读我们的',
  privaypolicy: '隐私政策',
  Transactions: '交易',
  NoTransaction: '您没有交易',
  Historyofyourransactionswillbehere: '您的交易历史记录将在此处显示',
  Settings: '设置',
  Language: '语言',
  English: '英语',
  Gereman: '波斯语',
  French: '法语',
  Logout: '退出',
  logotTitle: '退出帐户？',
  logoutDescription: '您将退出帐户，请稍后再登录。',
  confirmLogout: '是，退出。',
  skipLogout: '取消。',
  savesettings: '保存设置。',
  emailInvalid: '邮箱无效。',
  Neworder: '新订单',
  Service: '服务',
  poperLoading: '请稍候',
  Pickup: '取货',
  SetPickup: '设置取货地点',
  ChooseoOnMap: '在地图上选择',
  Fornow: '目前',
  Scheduled: '已安排',
  before: '之前：',
  after: '之后：',
  confirm: '确认',
  Settime: '设置时间',
  Cancel: '取消',
  Pleasetryanotherkeyword: '请尝试其他关键字',
  Noinformationfound: '未找到信息',
  address: '地址',
  block: '阻止',
  Floor: '楼层',
  Unit: '单元',
  senderfullname: '发件人姓名',
  senderphonenumber: '发件人编号',
  notesfordriver: '司机备注',
  DropOff: '送件地点',
  SetDropOff: '设置送件地点',
  fetchingdata: '正在接收信息...',
  Recieverfullname: '收件人姓名',
  Recieverphonenumber: '收件人编号',
  PromotionCode: '优惠码',
  Delete: '删除',
  Save: '保存',
  PromoCodeValid: '优惠码已保存',
  SenderWallet: '钱包',
  SenderCash: '现金',
  ReceiverCash: '收款人付款',
  lowBalance: '余额低',
  Balance: '钱包',
  Methods: '支付方式',
  balanceError: '您的余额必须至少等于订单金额',
  SendOrder: '发送订单',
  feedback: '反馈',
  Feedback: '反馈',
  Orderagain: '再次订购',
  Createdsuccessfully: '创建成功',
  chooseAmount: '选择金额',
  orenterthepreferedamount: '首选金额：',
  enteramount: '您的期望价格',
  pay: '支付',
  selectPaymentGateway: '选择支付网关',
  Time_MachineText: '您是否要恢复之前未注册的订单信息？',
  yes: '是',
  ignore: '忽略',
  Order: '订单',
  statusPending: '待处理',
  statusUnassigned: '未分配',
  statusAssigned: '已分配',
  statusStarted: '已开始',
  statusPickedUp: '已取货',
  statusDone: '完成',
  statusCustomerCanceled: '客户已取消',
  statusDriverCanceled: '司机已取消',
  statusArrived: '已到达',
  statusSupportCanceled: '客服已取消',
  statusCanceled: '已取消',
  Phone: '电话',
  additonalservice: '附加服务',
  CallDriver: '致电司机',
  Message: '消息',
  orderInfoError: '接收信息时出错',
  support: '客服',
  map: '地图',
  receipt: '收据',
  photo: '照片',
  ServicePhoto: '服务照片',
  Addphoto: '添加照片',
  Estime: '预计时间',
  Espath: '预计路径',
  pod: '送达证明',
  Notes: '备注',
  Photo: '照片',
  Signature: '签名',
  Nonotes: '无备注',
  Nosignature: '无签名',
  Nophoto: '无照片',
  Price: '价格',
  Receiver: '收货人',
  Sender: '发货人',
  Cash: '现金',
  Canceltravel: '取消请求',
  CancellText: '取消后，司机的订单将被取消',
  Estimated: '预估',
  Wallet: '余额',
  Copylink: '复制链接',
  repeatOrder: '重复订单',
  Edit: '编辑',
  confirmCancel: '是',
  paymentmethod: '付款方式',
  SucceessFul: '已成功完成',
  errorinServer: '服务器问题',
  Comment: '评论',
  Exfeedbackinput: '例如送货很快',
  Wallett: '钱包',
  TypeHere: '在此输入',
  Loadingmessages: '正在加载消息',
  PoweredBy: '由 DeliveryBooking 提供支持',
  newincomemessage: '您收到一条新消息',
  newincomemessageanother: '您在另一个订单中有一条新消息',
  youhaveunreadmessage: '未读消息',
  Vehicletype: '车辆类型',
  Pickup2: '取货',
  Dropoff2: '送货',
  Events: '活动',
  allEvents: '所有活动',
  star: '星级',
  Yourrate: '您的评分',
  CopyOrderlink: '复制订单链接',
  CopyPickuplink: '复制取货链接',
  CopyDeliverylink: '复制送货链接',
  Nointernetconnection: '无网络连接',
  close: '关闭',
  seen: '已查看',
  controlThatbeforeLoweEqualAfter: '时间“之前：”不能小于“之后：”',
  controlThatbeforeAndAfterMustBiggerthanCurrentDate: '“之前：”和“之后：”的时间不能短于当前时间',
  errorInPanelSetting: '预订设置错误，请联系客服',
  Arabic: '阿拉伯语',
  ar: '阿拉伯语',
  veeDeliveryLoginText1: '立即发送任何内容',
  veeDeliveryLoginText2: '给任何人！',
  Schedule: '时间表',
  Date: '日期',
  Time: '时间',
  noDateToShow: '没有可显示的日期',
  noTimeToShow: '没有可显示的时间',
  Apply: '申请',
  Increaseyourbalance: '增加您的余额',
  AddBalance: '添加余额',
  Addressbook: '地址簿',
  AddressbookSearchbar: '按地址、标题和代码搜索',
  Removedefault: '按地址、标题和代码搜索',
  Setdefaultpickup: '设置默认取件人',
  Remove: '删除',
  newAddress: '新地址',
  NewAddressbookInfoTitle: '信息',
  Addressdetails: '地址详情',
  Title: '标题',
  Code: '代码',
  editAddress: '编辑地址',
  AddressbookDropOf: '地址簿（投递）',
  AddressbookPickup: '地址簿（取件）',
  hide: '隐藏',
  Nosavedaddress: '未保存地址',
  NosavedaddressDesc: '您可以点击地址旁边的书签图标或前往地址簿页面创建一个地址',
  Romanian: '罗马尼亚语',
  ro: '罗马尼亚语',
  Dutch: '荷兰语',
  Shipmentlabel: '发货标签',
  Name: '名称',
  CashOnDelivery: '货到付款',
  EnterAmount: '输入金额',
  COD: '货到付款',
  Surchargexxx: '附加费 xxx',
  Pricedetails: '价格详情',
  minxxx: 'xxx 分钟',
  toPickup: '到取件处',
  toDropOff: '到投递处',
  AddCreditCard: '添加信用卡/借记卡',
  CustomerWallet: '客户钱包',
  Add: '添加',
  Addedsuccessfully: '添加成功',
  paymentmethods: '付款方式',
  NoCards: '无卡',
  Listofyourcardswillbehere: '您的卡列表将在此处显示',
  CardInfo: '卡信息',
  ExpireDate: '到期日期',
  CVC: 'CVC',
  PostalCode: '邮政编码',
  RemoveCardq: '移除卡？',
  RemoveCardA: '该卡将被移除，无法再使用',
  YesRemove: '是，移除',
  Cardisinuse: '该卡正在使用中',
  ok: '确定',
  Pleasetypeyourwordstosearch: '请输入您的关键字进行搜索',
  spanish: '西班牙语',
  es: '西班牙语',
  Invoices: '发票',
  noInvoice: '编号 xxx',
  germany: '德国',
  nl: '荷兰语',
  downloadClientApplication: '下载 xxx 应用程序',
  AssignedAt: '指定收款日期 xxx',
  StartedAt: '开始日期 xxx',
  ArrivedAt: '到达日期 xxx',
  PickedUpAt: 'xxx 取货日期',
  DoneAt: 'xxx 结束日期',
  Russian: '俄语',
  Azerbaijani: '阿塞拜疆语',
  rus: '俄语',
  aze: '阿塞拜疆语',
  Support: '支持',
  SendRequest: '发送请求',
  CallTheSupport: '致电支持',
  Choosethesubject: '选择主题',
  Seefrequentquestions: '查看常见问题',
  Details: '详细信息',
  Send: '发送',
  MessageBox: '消息框',
  NoMessages: '暂无消息',
  Yourmessageswillbehere: '您的消息将在此处显示',
  Portuguese: '葡萄牙语',
  pt: '葡萄牙语',
  Greek: '希腊语',
  el: '希腊语',
  individual: '个人',
  comingsoondesc2: '如需创建企业账户，请联系我们',
  contactUs: '联系我们',
  changePassword: '更改密码',
  changePasswordp1: '您将离开所有会话，但此会话除外，为了保护您的账户，尝试访问的人',
  changePasswordp2: '您的密码至少应为 6 个字符',
  currentPassword: '当前密码',
  newpassword: '新密码',
  Retypenewpassword: '再次输入新密码',
  account: '账户（钱包）',
  Required: '必填',
  registerBussinessUsername: '用户名（至少（5 个字符）',
  registerBussinessPassword: '密码（至少 6 个字符）',
  ReferenceID: '参考 ID',
  EnterId: '输入 ID',
  Orderid: '订单 ID',
  EnterCode: '输入代码',
  AustrianGerman: '奥地利语 德语',
  deu: '奥地利语 德语',
  pop: '取货证明',
  Options: '选项',
  RequiredText: '必填',
  PleaseSelect: '请选择',
  Optimizedropoffs: '优化下单',
  'Optimizedropoffs?': '优化下单？',
  OptimizedropoffsDesc: '下单顺序将更改为优化顺序，价格可能会有所调整',
  Optimize: '优化',
  zh: '简体中文',
  ChineseSimplified: '简体中文',
  Bulkimport: '批量导入',
  processing: '处理中',
  done: '完成',
  failed: '失败',
  Draft: '草稿',
  Uploading: '上传中',
  Draganddropyourfile: '拖放您的文件',
  Onlycsvformatissupported: '仅支持 .csv 格式',
  ORyoucan: '或者您可以',
  Openfile: '打开文件',
  Noimportsyet: '尚无导入',
  NoimportsyetDesc: '您可以在此处查看导入列表并检查其状态',
  nosupportdialogeTitle: '文件格式不受支持',
  nosupportdialogeText: 'xxx 文件不受支持。您只能上传包含订单信息的 .csv 文件。',
  Import: '导入',
  previewTitle: '预览并选择“选项”',
  previewDesc: '这是您文件中的第一项，用于检查您的信息是否结构正确。',
  Upload: '上传',
  ServiceandOrdertype: '服务和订单类型',
  Fileisproccessing: '文件正在处理中……',
  proccessingDesc: '您可以刷新以查看结果是否已完成。',
  serverError: '服务器错误',
  isRequired: 'xxx 为必填项。',
  Result: '结果',
  ResultText: '您可以在此处查看问题，并下载这些行进行单独修复。',
  ErrorDetails: '出错的订单',
  ErrorDetailsText: '出错的订单列在下方可下载的文件中。其中包含每行的错误详情。',
  DownloadErroredRows: '下载错误行',
  importedsuccessfully: 'xxx 订单已成功导入',
  ordershaserrors: 'xxx 订单有错误',
  refresh: '刷新',
  pleaseSellectParsel: '请选择服务',
  Ondemand: '按需配送',
  PickupandDelivery: '自提和配送',
  PickupDelivery: '自提和配送',
  Delivery: '配送',
  tab_Delivery: '配送',
  tab_Ondemand: '按需配送',
  tab_Pickup: '自提',
  tab_PickupDelivery: '配送和配送',
  Downloadsamplecsv: '下载 CSV 示例',
  Distance: '距离',
  Duration: '时长',
  driverPhoto: '司机照片',
  yourPhoto: '您的照片',
  No: '否',
  confirmCancel2: '是，取消订单',
  UploadPhoto: '上传照片',
  Photos: '照片',
  ParcelPhoto: '包裹照片',
  ProofofPickup: '取货证明',
  EditPhoto: '编辑照片',
  TrackLink: '追踪链接',
  ShipmentLabel: '发货标签',
  Receipt: '收据',
  Confirm: '确认',
  BulkEditStatusSummary: '批量编辑状态摘要',
  Successful: '成功',
  Failed: '失败',
  OrderID: '订单 ID',
  New: '新建',
  Clear: '清除',
  Noresultfound: '未找到结果',
  Typeyourkeyword: '输入您的关键字',
  Typeintheinputtostartsearch: '输入内容开始搜索',
  OnDemand: '按需配送',
  P_Hub_D: 'P_Hub_D',
  AddressDetails: '地址详情',
  Map: '地图',
  'BulkEditStatusxxx/yyy': '批量编辑状态 xxx/yyy',
  'xxxSuccessfull,yyyFailed': 'xxx 成功，yyy 失败',
  xxxfromyyy: 'xxx 来自 yyy',
  xxxrows: 'xxx 行',
  xxxselected: 'xxx 已选择',
  xxxdropoffs: 'xxx 个下车点',
  'Status Updated at xxx': '状态更新于 xxx',
  More: '更多',
  Summary: '摘要',
  Prev: '上一个',
  Next: '下一个',
  ClearAll: '清除全部',
  Errorinloadingdata: '数据加载错误',
  Therewasaproblemloadingdatapleasetryagainorcontactsupport: '数据加载出现问题，请重试或联系客服',
  Tryagain: '重试',
  ConfigTable: '配置表格',
  ActiveColumns: '活动列',
  Createyourorder: '创建订单',
  Yourorderswillbeshownhere: '您的订单将显示在此处',
  Pleasecheckyourfiltersorkeyword: '请检查您的筛选条件或关键字',
  CustomerPhoto: '客户照片',
  NoAttachments: '无附件',
  AllAttachmentswillbeshownhere: '所有附件将显示在此处',
  Scheduleoverlap: '预约取货时间必须早于预约送货时间，且不可重叠',
  SearchAddress: '搜索地址',
  NoResultfromLocalDatabaseD: '请重试或尝试其他关键字',
  NoResultfromMapService: '地图服务未显示结果',
  Senderinfo: '发件人信息',
  Receiverinfo: '收件人信息',
  SchedulePickup: '预约取货',
  ScheduleDelivery: '预约送货',
  Fullname: '全名',
  addressDetail: '地址详情',
  Addtoaddressbook: '添加到地址簿',
  ExHome: '例如：家庭',
  Ex123: '例如：123',
  Savechanges: '保存更改',
  Removefromaddressbook: '从地址簿中移除？',
  RemovefromaddressbookDesc: '此地址及其输入的详细信息将添加到您的地址簿。',
  Clearfield: '清除字段',
  CreateOrder: '创建订单',
  Walletbalanceislow: '钱包余额不足',
  Walletbalanceislowd: '要使用钱包，您的余额必须至少等于订单金额。',
  'Selected date and time': '选定日期和时间',
  Vehicle: '车辆',
  Other: '其他',
  'Fill in or Select': '填写或选择',
  Fields: '字段',
  OrderType: '订单类型',
  Stage: '阶段',
  Status: '状态',
  CreatedAt: '创建时间',
  StatusUpdatedAt: '状态更新时间',
  Note: '备注',
  ReferenceId: '参考ID',
  PickupAddress: '取货地址',
  DeliveryAddress: '送货地址',
  EstimatedDistanceInMeters: '预计距离（米）',
  EstimatedDuration: '预计时长',
  'Payment Method': '付款方式',
  PickupAddressDetail: '取货地址详情',
  PickupCompleteAfter: '取货完成时间',
  PickupcompleteBefore: '取货完成时间',
  PickupFullName: '取货全名',
  PickupPhone: '取货电话',
  PickupEmail: '取货邮箱',
  PickupPodNote: '取货舱备注',
  PickupPodPhoto: '取货舱照片',
  PickupPodSignature: '取货舱签名',
  DeliveryAddressDetail: '送货地址详情',
  DeliveryCompleteAfter: '送货完成时间',
  DeliverycompleteBefore: '送货完成时间',
  DeliveryFullName: '送货全名',
  DeliveryPhone: '送货电话',
  DeliveryEmail: '送货邮箱',
  DeliveryPodNote: '送货舱备注',
  DeliveryPodPhoto: '送货舱照片',
  DeliveryPodSignature: '送货舱签名',
  'Customer Email': '客户邮箱',
  PaymentProvider: '支付服务提供商',
  'Shipment Label': '发货标签',
  'Track Order': '追踪订单',
  Stages: '阶段',
  CodAmount: '货到付款金额',
  selected: '已选择',
  from: '来自',
  rows: '行',
  'Select Status': '选择状态',
  'Select Reason': '选择原因',
  'Edit Status': '编辑状态',
  Czech: '捷克语',
  cs: '捷克语',
  Persian: '波斯语',
  'Pickup Address': '取货地址',
  'You must assign driver to select this route': '您必须指定司机才能选择此路线',
  'You must choose an unassigned route or unassign selected route': '您必须选择未指定的路线或取消指定路线',
  'Collection from': '取货地点',
  'Added to address book': '已添加到通讯录',
  'Add to address book': '已添加到通讯录',
  ASAP: '尽快',
  'Time slot': '时间段',
  'Set time slot': '设置时间段',
  'Deliver to': '送达',
  'Add dropoff': '添加送达点',
  refid_tooltip: '“使用此 ID 添加内部 ID，以便您识别送货。如有需要，此 ID 也会显示在发票和快递员信息上”',
  'Pay By Card': '刷卡支付',
  'Add Card': '添加银行卡',
  'On Account': '账户支付',
  'No card added': '未添加银行卡',
  Schedulepickup: '安排取货',
  Scheduledelivery: '安排送达',
  'Business account': '企业账户',
  'Email/Username': '邮箱/用户名',
  'Forgot your password?': '忘记密码？',
  'Send link': '发送链接',
  'Link sent': '链接已发送',
  'Return to login': '返回登录',
  Verify: '验证',
  'Login to your account': '登录您的账户',
  'Register as business': '注册为企业',
  'Continue using Email / Username': '继续使用邮箱/用户名',
  'Don’t have an account?': '没有账户？',
  OR: '或',
  'Register as individual': '注册为个人',
  'Repeat password': '重复密码',
  'Ex. London': '例如：伦敦',
  'Privacy Policy.': '隐私政策。',
  and: '和',
  'Terms of Use': '使用条款',
  'By continuing, you agree to Onro’s': '继续，即表示您同意 Onro 的',
  'Business Email': '商务邮箱',
  'Ex. example@example.com': '例如：example@example.com',
  'Contact name': '联系人姓名',
  'Ex. John Leo': '例如：John Leo',
  'Ex. Leo': '例如：Leo',
  'Enter your new password': '输入新密码',
  'Password must be at least 6 characters': '密码必须至少包含 6 个字符',
  'Repeat password doesn’t match': '重复输入的密码不一致',
  'Password changed': '密码已更改',
  'Return to app and login again': '返回应用并重新登录',
  Change: '更改',
  'Continue with Apple': '继续使用 Apple 账户',
  'Continue with Facebook': '继续使用 Facebook 账户',
  'Change password': '更改密码',
  DeliveryMethod: '配送方式',
  'Search and select service point': '搜索并选择服务点',
  'Add service points in admin center': '在管理中心添加服务点',
  'No service point available': '无可用服务点',
  'Add service point': '添加服务点',
  'All Service points': '所有服务点',
  'Service point': '服务点',
  statusAtPickupServicePoint: 'AtPickupServicePoint',
  statusAtDeliveryServicePoint: 'AtDeliveryServicePoint',
  EDAS_AtDeliveryServicePoint: 'AtDeliveryServicePoint',
  EDAS_AtPickupServicePoint: 'AtPickupServicePoint',
  Preview: '预览',
  'Error in optimization': '优化错误',
  Person: '个人',
  fo: '对于',
  undefined: '服务类别'
}